import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminSystemPageComponent } from './admin-system.page';

const routes: Routes = [
  {
    path: '',
    component: AdminSystemPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminSystemPageRoutingModule {}
